/**
 * Normalize AI-generated KB titles: Title Case per word and ensure org/company name appears when provided.
 */

export function toTitleCaseWords(input: string): string {
  const s = (input || "").trim();
  if (!s) return s;
  return s
    .split(/\s+/)
    .map((word) => {
      const parts = word.split(/([-–—])/);
      return parts
        .map((part) => {
          if (!part || part === "-" || part === "–" || part === "—") return part;
          if (/^['"(\[]?$/.test(part)) return part;
          return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        })
        .join("");
    })
    .join(" ");
}

/** If `companyDisplayName` is set and no recognizable token appears in the title, prefix "Name — ". */
export function formatAiKbTitle(rawTitle: string, companyDisplayName: string): string {
  const raw = (rawTitle || "").trim();
  const company = (companyDisplayName || "").trim();
  const base = raw ? toTitleCaseWords(raw) : company ? `${toTitleCaseWords(company)} Article` : "Knowledge Base Article";
  if (!company) return base;
  const low = base.toLowerCase();
  const cLow = company.toLowerCase();
  if (low.includes(cLow)) return base;
  const tokens = company.split(/\s+/).filter((t) => t.length > 2);
  if (tokens.some((t) => low.includes(t.toLowerCase()))) return base;
  return `${toTitleCaseWords(company)} — ${base}`;
}
